var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`savoirplus-6`, _vm.className || ``]},[_c('a',{staticStyle:{"text-decoration":"none"},attrs:{"href":_vm.link}},[_c('div',{staticClass:"en-savoir-plus montserrat-medium-gunsmoke-18px"},[_vm._v(_vm._s(_vm.children))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }